import { flex } from "@styled-system/patterns";

export const actionButtonWrapperClass = flex({
	alignItems: "center",
	gap: "8",
});
